import { Building2, ClipboardCheck, FileCheck2, Flag, FolderOpen, LayoutDashboard, ShieldAlert, Users } from 'lucide-react';
import { headquartersNavigationPages, type HeadquartersPage } from './headquarters-pages';

const icons = { dashboard: LayoutDashboard, halfyear: FileCheck2, emphasis: Flag, meetings: Users,
  inspections: ClipboardCheck, accidents: ShieldAlert, sites: Building2, library: FolderOpen };

export function HeadquartersNavigation({ page, onNavigate, canReadLibrary }: {
  page: HeadquartersPage | null;
  onNavigate: (page: HeadquartersPage) => void;
  canReadLibrary: boolean;
}) {
  return <nav aria-label="본사 업무">{headquartersNavigationPages.map(item => {
    const Icon = icons[item.id];
    return <button key={item.id} type="button" data-hq-page={item.id}
      className={page === item.id ? 'active' : ''} aria-current={page === item.id ? 'page' : undefined}
      aria-label={item.label} title={item.label} disabled={item.id === 'library' && !canReadLibrary}
      onClick={() => onNavigate(item.id)}>
      <span className="direct-navigation-icon"><Icon size={21}/></span>
      <span className="direct-navigation-label">{item.shortLabel}</span>
    </button>;
  })}</nav>;
}
